import { useContext, useState } from 'react'
import { webFetch } from 'shared/api'
import { PublicAPIError } from 'shared/api/errors'
import Grid from 'shared/components/grid'
import SearchOptionsContext from 'shared/contexts/search-options'
import { SearchOptionsPageData } from 'shared/types/page-data'
import Header from '../components/header/header'
import { ExploreHeader } from './header/header'

type Props = {
    search: SearchOptionsPageData
    isExplore?: boolean
}

declare global {
    interface Window {
        showExploreClipCarousel: boolean
    }
}

const Search = ({ search, isExplore }: Props) => {
    const { term } = search
    const { type, sort, setSearchResponseId, searchResponseId } = useContext(SearchOptionsContext)
    const [totalCount, setTotalCount] = useState<number>()
    const fetchGifs = async (offset: number) => {
        const result = await webFetch.search(term, {
            offset,
            type,
            sort,
        })

        if (!result?.pagination) {
            throw new PublicAPIError('Error fetching gifs (Component: Search)')
        }
        setTotalCount(result.pagination.total_count)
        if (!searchResponseId) setSearchResponseId(result.meta.response_id)
        return result
    }
    return (
        <>
            {isExplore ? (
                <ExploreHeader searchInfo={search} isSticker={search.isSticker} />
            ) : (
                <Header searchInfo={search} totalCount={totalCount} />
            )}
            <Grid
                gridTitle={(isExplore && 'All the GIFs') || ''}
                key={`${type} ${sort}`}
                columns={4}
                fetchGifs={fetchGifs}
            />
        </>
    )
}

export default Search
